// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + "e690f8eb248ef212afb6" + ".css";
};